"use strict";

var _regeneratorRuntime = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useApplication = exports.ApplicationProvider = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var Models_1 = require("./Models");

var Authentication_1 = __importStar(require("./Authentication"));

var frontend_common_1 = require("@ryerson/frontend.common");

var common_permissions_1 = require("@ryerson/common.permissions");

var axios_1 = __importDefault(require("axios"));

var frontend_common_2 = require("@ryerson/frontend.common"); // CONTEXT


var ApplicationContext = react_1.default.createContext({}); // PROVIDER

var ApplicationProvider = function ApplicationProvider(_ref) {
  var children = _ref.children,
      defaultLocalization = _ref.localization,
      defaultLocation = _ref.location,
      apimSubscriptionKey = _ref.apimSubscriptionKey,
      googleApiKey = _ref.googleApiKey,
      _ref$envUrl = _ref.envUrl,
      envUrl = _ref$envUrl === void 0 ? undefined : _ref$envUrl,
      _ref$isNative = _ref.isNative,
      isNative = _ref$isNative === void 0 ? false : _ref$isNative;
  // This ref which get set as true if there is no zipcode in localStorage while initializing zipcode state.
  var noZipOnLoadRef = (0, react_1.useRef)(false);

  var _ref2 = (0, react_1.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      isMounted = _ref3[0],
      setIsMounted = _ref3[1];

  var _ref4 = (0, react_1.useState)(function () {
    var sessionZipCode = (0, frontend_common_1.getLocalItem)(frontend_common_1.SessionItems.zipCode);

    if (!(sessionZipCode === null || sessionZipCode === void 0 ? void 0 : sessionZipCode.length)) {
      noZipOnLoadRef.current = true;
    }

    return sessionZipCode || frontend_common_1.Default.ZIPCODE;
  }),
      _ref5 = _slicedToArray(_ref4, 2),
      zipCode = _ref5[0],
      setZipCode = _ref5[1]; //create a ref to store zip code update


  var _ref6 = (0, react_1.useState)(function () {
    var isSystemUpdate = (0, frontend_common_1.getLocalItem)(frontend_common_1.SessionItems.zipCodeSystemUpdate);
    return isSystemUpdate === "true" ? true : false;
  }),
      _ref7 = _slicedToArray(_ref6, 2),
      zipCodeSystemUpdate = _ref7[0],
      setZipCodeSystemUpdate = _ref7[1];

  var permissionsUtility = (0, react_1.useRef)(new common_permissions_1.UserPermission(undefined));

  var _ref8 = (0, react_1.useState)(function () {
    var _a, _b;

    var storedUser = (0, frontend_common_1.getLocalItem)(frontend_common_1.SessionItems.user);

    if (storedUser) {
      var _user = JSON.parse(storedUser);

      var now = new Date().getTime() / 1000;
      var transferring = ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname) === null || _b === void 0 ? void 0 : _b.startsWith("/login/transfer")) || false;

      if (_user.isLoggedIn && _user.expires && _user.expires > now + 60 && !transferring) {
        // User token from storage is valid for at least 60 more seconds so we can use it.
        return _user;
      }
    } // Using the default logged out user.


    return Authentication_1.default.loggedOutUser;
  }),
      _ref9 = _slicedToArray(_ref8, 2),
      user = _ref9[0],
      setUserPrivate = _ref9[1];

  var _ref10 = (0, react_1.useState)(function () {
    var storeLocalization = (0, frontend_common_1.getLocalItem)(frontend_common_1.SessionItems.localization);
    return storeLocalization && JSON.parse(storeLocalization) || {
      country: defaultLocalization.country,
      language: defaultLocalization.language
    };
  }),
      _ref11 = _slicedToArray(_ref10, 2),
      localization = _ref11[0],
      setLocalization = _ref11[1];

  var _ref12 = (0, react_1.useState)(function () {
    var storedLocation = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.location);
    var value = storedLocation && Object.values(Models_1.Location).includes(storedLocation) && storedLocation;
    return value || defaultLocation;
  }),
      _ref13 = _slicedToArray(_ref12, 2),
      location = _ref13[0],
      setLocation = _ref13[1];

  var _ref14 = (0, react_1.useState)(function () {
    var storedProfile = (0, frontend_common_1.getLocalItem)(frontend_common_1.SessionItems.profile);
    return storedProfile && JSON.parse(storedProfile) || null;
  }),
      _ref15 = _slicedToArray(_ref14, 2),
      profile = _ref15[0],
      setProfile = _ref15[1];

  var setUser = function setUser(user) {
    Authentication_1.default.setupAxiosInterceptors(axiosInstance, apimSubscriptionKey, user, setUser, setProfile, setZipCode);
    setUserPrivate(user);
  };

  var _ref16 = (0, react_1.useState)(function () {
    var axiosInstance = axios_1.default.create();
    envUrl && (axiosInstance.defaults.baseURL = envUrl);
    Authentication_1.default.setupAxiosInterceptors(axiosInstance, apimSubscriptionKey, user, setUser, setProfile, setZipCode);
    return axiosInstance;
  }),
      _ref17 = _slicedToArray(_ref16, 1),
      axiosInstance = _ref17[0]; // Set Location info


  (0, react_1.useEffect)(function () {
    isMounted && location && sessionStorage.setItem(frontend_common_1.SessionItems.location, location);
  }, [location]); // Set Language

  (0, react_1.useEffect)(function () {
    isMounted && localStorage.setItem(frontend_common_1.SessionItems.localization, JSON.stringify(localization));
  }, [localization]); // Set User Profile

  (0, react_1.useEffect)(function () {
    if (isMounted) {
      localStorage.setItem(frontend_common_1.SessionItems.profile, JSON.stringify(profile));
    }
  }, [profile]); // Set User info

  (0, react_1.useEffect)(function () {
    permissionsUtility.current.setToken(user === null || user === void 0 ? void 0 : user.token);
    isMounted && localStorage.setItem(frontend_common_1.SessionItems.user, JSON.stringify(user));
  }, [user]); //useEffect on zipCodeSystemUpdate

  (0, react_1.useEffect)(function () {
    localStorage.setItem(frontend_common_1.SessionItems.zipCodeSystemUpdate, zipCodeSystemUpdate ? "true" : "false");
  }, [zipCodeSystemUpdate]);

  var getUserProfile = function getUserProfile() {
    axiosInstance.get("".concat(frontend_common_2.ApiUrl.PROFILE)).then(function (response) {
      var responseData = response === null || response === void 0 ? void 0 : response.data;

      if (responseData) {
        setProfile(responseData);
      }
    }).catch(function (err) {
      console.warn(err);
    });
  };

  (0, react_1.useEffect)(function () {
    Authentication_1.default.setupAxiosInterceptors(axiosInstance, apimSubscriptionKey, user, setUser, setProfile, setZipCode);
  }, [apimSubscriptionKey, setUser, setProfile]);

  var hasPermission = function hasPermission(permission) {
    return permissionsUtility.current.has(permission);
  };

  var login = function login(userLoginRequest) {
    return Authentication_1.default.login(axiosInstance, setUser, userLoginRequest);
  };

  var logout = function logout() {
    return Authentication_1.default.logout(setUser, setProfile, setZipCode);
  };

  var refreshToken = function refreshToken(config) {
    return Authentication_1.default.refreshToken(config || axiosInstance.defaults, axiosInstance, setUser, setProfile, setZipCode);
  };

  var isGuestUser = function isGuestUser() {
    return !!(user.isLoggedIn && (!user.account || user.account && frontend_common_1.GUEST_ACCOUNTS.includes(user.account)));
  };

  (0, react_1.useEffect)(function () {
    if (user.isLoggedIn && (!profile || user.userId !== profile.userId || user.account !== profile.customer.customerNumber)) {
      getUserProfile();
    }
  }, [user]);
  (0, react_1.useEffect)(function () {
    // When we initialized the user variable above, it is possible that we had an expired user and profile in storage and we need to clear storage.
    var storedUserString = (0, frontend_common_1.getLocalItem)(frontend_common_1.SessionItems.user);

    if (storedUserString) {
      var storedUser = JSON.parse(storedUserString);

      if (!user.isLoggedIn && storedUser.isLoggedIn) {
        localStorage.setItem(frontend_common_1.SessionItems.user, JSON.stringify(user));
      }
    }

    if (!user.isLoggedIn && profile != null) {
      setProfile(null);
    }
  }, []);
  /**
   * onStorageUpdate
   *
   * @remarks
   * Event handler for storage update: used fore sync across tabs
   */

  var onStorageUpdate = function onStorageUpdate(e) {
    var key = e.key,
        newValue = e.newValue;
    var newValueObject = (newValue === null || newValue === void 0 ? void 0 : newValue.includes("}")) ? JSON.parse(newValue) : undefined;

    if (key === frontend_common_1.SessionItems.user) {
      var _ref18 = newValueObject || {},
          JWT = _ref18.token,
          isLoggedIn = _ref18.isLoggedIn;

      !!JWT && permissionsUtility.current.setToken(JWT);

      if (!!newValueObject && isLoggedIn) {
        (0, Authentication_1.setLoggedInUser)(JWT, setUser);
      } else if (!!newValueObject && !isLoggedIn) {
        logout();
      }
    } else if (key === frontend_common_1.SessionItems.profile) {
      newValueObject && setProfile(newValueObject);
    } else if (key === frontend_common_1.SessionItems.zipCode) {
      newValue && setZipCode(newValue);
    } else if (key === frontend_common_1.SessionItems.localization) {
      newValue && setLocalization(newValueObject);
    } else if (key === frontend_common_1.SessionItems.zipCodeSystemUpdate) {
      newValue && setZipCodeSystemUpdate(newValueObject);
    }
  };

  (0, react_1.useEffect)(function () {
    if (typeof window !== "undefined" && isMounted) {
      window.addEventListener("storage", onStorageUpdate);
    }

    return function () {
      window.removeEventListener("storage", onStorageUpdate);
    };
  }, [isMounted]);
  /**
   * Mount - Get zipCode
   *
   * @remarks
   * 1  Attempt to get users zipCode if logged in or from SessionStorage
   * 1.5 If using native mobile app, use geolocation capacitor plugin.
   * 2  If not available attempt to get geo location from browser if (not blocked by client)
   * 3. If user's browsers provides long lat, call API to get zip, else call Utility to get zip
   * 4. set zipCode in state and session param
   *
   * Note - Pascal case imposed by API call, zipCode will default to Lisle if not available
   */

  var setZipFromLatLong = function setZipFromLatLong(_ref19) {
    var latitude = _ref19.latitude,
        longitude = _ref19.longitude,
        url = _ref19.url;
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var body, _yield, _yield$error, error, address;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // call api
              body = {
                Longitude: "".concat(longitude),
                Latitude: "".concat(latitude)
              };
              _context.next = 3;
              return (0, frontend_common_1.addressFromGeoLocation)(url, axiosInstance, body);

            case 3:
              _yield = _context.sent;
              _yield$error = _yield.error;
              error = _yield$error === void 0 ? "" : _yield$error;
              address = _yield.address;
              setZipCodeSystemUpdate(true);

              if (!error && address.ZipCode) {
                setZipCode(address.ZipCode);
              } else {
                setZipCode(frontend_common_1.Default.ZIPCODE);
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };

  var getZipCodeFromGeoLocation = function getZipCodeFromGeoLocation() {
    var _a, _b;

    if (typeof window !== "undefined" && ((_b = (_a = window === null || window === void 0 ? void 0 : window.Capacitor) === null || _a === void 0 ? void 0 : _a.Plugins) === null || _b === void 0 ? void 0 : _b.Geolocation)) {
      // check if native app
      (function () {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var geolocation, permissions, getPositionOptions, coordinates, _coordinates$coords, latitude, longitude;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  geolocation = window.Capacitor.Plugins.Geolocation;
                  permissions = geolocation.checkPermissions();
                  getPositionOptions = {
                    enableHighAccuracy: false
                  };

                  if (![permissions.location, permissions.coarseLocation].includes("granted")) {
                    _context2.next = 9;
                    break;
                  }

                  _context2.next = 6;
                  return geolocation.getCurrentPosition(getPositionOptions);

                case 6:
                  coordinates = _context2.sent;
                  _context2.next = 14;
                  break;

                case 9:
                  _context2.next = 11;
                  return geolocation.requestPermissions();

                case 11:
                  _context2.next = 13;
                  return geolocation.getCurrentPosition(getPositionOptions);

                case 13:
                  coordinates = _context2.sent;

                case 14:
                  _coordinates$coords = coordinates.coords, latitude = _coordinates$coords.latitude, longitude = _coordinates$coords.longitude;
                  setZipFromLatLong({
                    latitude: latitude,
                    longitude: longitude,
                    url: frontend_common_2.ApiUrl.ADDRESS_GEOCODE
                  });

                case 16:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
      })();
    } else {
      (function () {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var url, _yield2, _yield2$error, error, longitude, latitude, _yield3, address, zipResult;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  //  geo loc from browser
                  url = "".concat(frontend_common_2.ApiUrl.ADDRESS_GEOCODE);
                  _context3.next = 3;
                  return (0, frontend_common_1.getBrowserLocation)();

                case 3:
                  _yield2 = _context3.sent;
                  _yield2$error = _yield2.error;
                  error = _yield2$error === void 0 ? "" : _yield2$error;
                  longitude = _yield2.longitude;
                  latitude = _yield2.latitude;

                  if (!error) {
                    _context3.next = 19;
                    break;
                  }

                  _context3.next = 11;
                  return (0, frontend_common_1.getAddressUsingIP)(url, axiosInstance, googleApiKey);

                case 11:
                  _yield3 = _context3.sent;
                  address = _yield3.address;
                  zipResult = (address === null || address === void 0 ? void 0 : address.ZipCode) || frontend_common_1.Default.ZIPCODE;
                  setZipCodeSystemUpdate(true);
                  setZipCode(zipResult);
                  localStorage.setItem(frontend_common_1.SessionItems.zipCode, zipResult);
                  _context3.next = 20;
                  break;

                case 19:
                  setZipFromLatLong({
                    latitude: latitude,
                    longitude: longitude,
                    url: url
                  });

                case 20:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
      })();
    }
  };

  (0, react_1.useEffect)(function () {
    var _a;

    if (isMounted) {
      var profileZipCode = (_a = profile === null || profile === void 0 ? void 0 : profile.customer) === null || _a === void 0 ? void 0 : _a.zip;

      if (!profileZipCode && noZipOnLoadRef.current) {
        noZipOnLoadRef.current = false;
        !localStorage.getItem(frontend_common_1.SessionItems.zipCode) && getZipCodeFromGeoLocation();
      }
    }
  }, [isMounted]);
  (0, react_1.useEffect)(function () {
    if (isMounted) {
      //if no zipCode then, get it from geoLocation
      if (!!zipCode) {
        localStorage.setItem(frontend_common_1.SessionItems.zipCode, zipCode);
      } else {
        getZipCodeFromGeoLocation();
      }
    }
  }, [zipCode]);
  (0, react_1.useEffect)(function () {
    setIsMounted(true);
  }, []);
  var exposed = {
    localization: localization,
    user: user,
    profile: profile,
    location: location,
    axiosInstance: axiosInstance,
    zipCode: zipCode,
    hasPermission: hasPermission,
    setLocalization: setLocalization,
    setProfile: setProfile,
    getUserProfile: getUserProfile,
    setUser: setUser,
    setLocation: setLocation,
    setZipCode: setZipCode,
    login: login,
    logout: logout,
    refreshToken: refreshToken,
    envUrl: envUrl,
    isNative: isNative,
    isGuestUser: isGuestUser,
    zipCodeSystemUpdate: zipCodeSystemUpdate,
    setZipCodeSystemUpdate: setZipCodeSystemUpdate
  };
  return (0, jsx_runtime_1.jsx)(ApplicationContext.Provider, {
    value: exposed,
    children: children
  });
};

exports.ApplicationProvider = ApplicationProvider;
exports.default = ApplicationContext;

function useApplication() {
  return react_1.default.useContext(ApplicationContext);
}

exports.useApplication = useApplication;